<template>
  <div class="content">
    <!-- Home jumbo -->
    <Jumbo class="main-jumbo" :spaced="spaced">
      <template #background>
        <div class="main-jumbo__background">
          <Moles :count="1" :scale="3" align="right" background="transparent" class="main-jumbo__moles" reversed />
        </div>
      </template>

      <template #before>
        <div class="main-jumbo__claim">
          <div class="main-jumbo__claim__title">
            Alguien tenía <br />
            que mejorar <br />
            las hipotecas
          </div>

          <div class="main-jumbo__claim__ctas">
            <Button tag="a" :href="route('funnel.new')">Simular una nueva hipoteca</Button>
            <Button tag="a" :href="route('funnel.improve')" btn-style="secondary">Mejorar mi hipoteca actual</Button>
          </div>
        </div>
      </template>

      <template #after>
        <div class="main-jumbo__house__wrapper">
          <HouseAnimation class="main-jumbo__house" />
          <ImageComponent
            class="main-jumbo__static-house"
            src="img/web/banner/banner-mobile.webp"
            alt="La casa de tus sueños"
            width="916"
          ></ImageComponent>
        </div>
      </template>
    </Jumbo>

    <div class="main-mobile-ctas">
      <Button tag="a" :href="route('funnel.new')">Simular una nueva hipoteca</Button>
      <Button tag="a" :href="route('funnel.improve')" btn-style="secondary">Mejorar mi hipoteca actual</Button>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
.content {
  @apply flex flex-col items-center;

  .main {
    &-jumbo {
      /deep/ .jumbo__content {
        @apply pb-0 lg:pb-xxl short:px-xxs short:pt-xxs short:gap-nano;
      }

      &__background {
        @apply absolute top-0 bottom-0 left-0 right-0 bg-brand-primary-light;
      }

      &__moles {
        @apply hidden lg:flex absolute top-0 bottom-0 right-0 xl:-left-xxl -left-giant 2xl:left-0 lg:bg-transparent lg:bg-gradient-to-r lg:from-gradient-summer-start lg:to-gradient-summer-end;
      }

      &__claim {
        @apply flex flex-col gap-y-xxs md:min-w-[26rem] items-center lg:items-start lg:pl-lg;

        &__title {
          @apply text-center lg:text-left short:text-xl;
        }

        &__ctas {
          @apply hidden lg:flex flex-col gap-y-xxs max-w-[18.75rem];
        }
      }

      &__house {
        @apply relative hidden lg:block mt-lg;

        &__wrapper {
          @apply w-full flex flex-col items-end;
        }
      }

      &__static-house {
        @apply w-full max-w-[28.625rem] lg:hidden relative;
      }
    }

    &-mobile-ctas {
      @apply lg:hidden p-xxs flex flex-col gap-y-xxxs w-[21.5rem];
    }
  }
}
</style>

<script>
import { onMounted, ref } from '@vue/composition-api';
import { onResize } from '@/lego/utils/window/screen';
import { getTouchedScreen } from '@/lego/utils/tailwind/screen';
import Jumbo from '@/lego/components/layout/Jumbo.vue';
import Moles from '@/lego/components/layout/Moles.vue';
import Button from '@/lego/components/buttons/Button.vue';
import ImageComponent from '@/lego/components/images/Image.vue';
import HouseAnimation from '@/lego/components/animations/House.vue';

export default {
  components: {
    Jumbo,
    Moles,
    Button,
    ImageComponent,
    HouseAnimation,
  },
  setup() {
    const breakpoints = { xs: false, sm: true };
    const spaced = ref(true);

    const updateSize = () => {
      const screen = getTouchedScreen(breakpoints);
      spaced.value = breakpoints[screen];
    };

    onMounted(() => {
      updateSize();
    });
    onResize(() => {
      updateSize();
    });

    return {
      spaced,
    };
  },
};
</script>
